import { EMOJI_GLYPHS } from './emoji-data';

interface SearchableEmojiShortcode {
	shortcode: string;
	normalized: string;
}

export const SEARCHABLE_EMOJI_SHORTCODES: readonly SearchableEmojiShortcode[] = Object.keys(EMOJI_GLYPHS).map((shortcode) => ({
	shortcode,
	normalized: shortcode.toLowerCase(),
}));
